import React from 'react';
import { Link } from 'react-router-dom';

import Modal from './../shared/Modal';
import Button from './../shared/Button';

const IntroModal = props => {
  const { onStart, isUSA, version } = props;
  // const sum = isUSA ? '$10' : '$5';
  // const sum = '$5';
  const profileLastVer = version !== 'v0' && version !== 'v1';
  if (profileLastVer) {
    return (
      <Modal>
        <h1>Congratulations!</h1>
        <h2>You are done with the tutorial! <br /> Now it is time to check the knowledge <br />you have acquired.</h2>
        <p>This test does not require much of your time, as it consists of only 19 single choice questions.<br />All of them are related to the tutorial you have just looked through. Good luck!</p>
        <Button onClick={onStart} block>Next stage</Button> <br />
        <Link to="/repeat-tutorial">Watch tutorial once again</Link>
      </Modal>
    );
  }
  return (
    <Modal>
      <h1>Great!</h1>
      <h2>You are now done with tutorial and it is a <br /> perfect time to check the knowledge <br /> acquired.</h2>
      <p>The test will take only 20 minutes of your <br /> time as it consists of 19 multiple choice <br /> questions. You will receive $5 for passing <br /> the test successfully.  Good luck!</p>
      <Button onClick={onStart} block>Start test</Button> <br />
      <Link to="/repeat-tutorial">Watch tutorial once again</Link>
    </Modal>
  );
};

export default IntroModal;



// WEBPACK FOOTER //
// ./src/components/AcademicTest/IntroModal.js